export default __webpack_public_path__ + "static/media/logo_bais.b23c1b76.png";